<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
                </nav>
            </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <h3>{{language_terms['GOOD_RECEIVE_NOTE']}}</h3>
                        </div>
                        <b-row v-if="$route.params.id == '_new'">
                            <b-col cols="12">
                                <form-wizard @on-complete="onComplete" title="" subtitle="" color="#5e72e4" :finishButtonText="language_terms['SUBMIT']">
                                    <tab-content :title="language_terms['WAREHOUSE_AND_MOVEMENT_SELECTION']" :before-change="beforeStepChangeFirstTab">
                                        <b-row>
                                            <b-col cols="3">
                                                <base-input :label="language_terms['TYPE']">
                                                    <el-select v-model="grn.type" filterable :placeholder="language_terms['TYPE']">
                                                        <el-option
                                                            v-for="option in types"
                                                            :key="option.code"
                                                            :label="language_terms[option.name]"
                                                            :value ="option.code">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="3">
                                                <base-input :label="language_terms['WAREHOUSE']">
                                                    <el-select v-model="grn.warehouse_id" filterable :placeholder="language_terms['WAREHOUSE']">
                                                        <el-option
                                                            v-for="option in warehouses"
                                                            :key="option.id"
                                                            :label="option.name"
                                                            :value ="option.id">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="3">
                                                <label class="form-control-label">{{language_terms["VENDOR"]}}</label>
                                                    <multiselect
                                                        :internalSearch = "false"
                                                        v-model="grn.vendor"
                                                        id="ajax"
                                                        label="name"
                                                        track-by="id"
                                                        placeholder="Type to search"
                                                        open-direction="bottom"
                                                        :options="vendors"
                                                        :multiple="false"
                                                        :searchable="true"
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :options-limit="300"
                                                        :limit="50"
                                                        :max-height="600"
                                                        :show-no-results="false"
                                                        :hide-selected="false"
                                                        @search-change="asyncFindVendor"
                                                        @input="onSelectVendor"
                                                    ></multiselect>
                                            </b-col>
                                            <b-col cols="3">
                                                <base-input :label="language_terms['DATE']">
                                                <flat-picker
                                                    slot-scope="{ focus, blur }"
                                                    @on-open="focus"
                                                    @on-close="blur"
                                                    style="background-color: white"
                                                    class="form-control datepicker"
                                                    v-model="grn.date">
                                                </flat-picker>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="12" v-if="grn.type == 'GRN_PO'">
                                             <base-input :label="language_terms['PURCHASE_ORDERS']" >
                                                <el-select v-model="grn.reference_id" filterable :placeholder="language_terms['PURCHASE_ORDERS']" >
                                                    <el-option
                                                        v-for="option in pos"
                                                        :key="option.document_id"
                                                        :label="option.code"
                                                        :value ="option.document_id">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                            </b-col>
                                            <b-col cols="12">
                                                <base-input :label="language_terms['REMARKS']">
                                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="grn.remarks"></textarea>
                                                </base-input>
                                            </b-col>
                                        </b-row>
                                    </tab-content>
                                    <tab-content :title="language_terms['GRN_ITEMS']">
                                        <b-row v-if="grn.type == 'GRN'">
                                            <b-col cols="3">
                                                <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                                <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="grn.product_code"/>
                                            </b-col>
                                            <b-col cols="2">
                                                <base-input :label="language_terms['LOCATIONS']" >
                                                    <el-select v-model="grn.location" filterable :placeholder="language_terms['LOCATIONS']" 
                                                        @change="onSelectLocation" value-key="id" :disabled="grn.product_id == '' ||grn.product_id == null">
                                                        <el-option
                                                            v-for="option in locations"
                                                            :key="option.id"
                                                            :label="option.name"
                                                            :value ="option">
                                                        </el-option>
                                                    </el-select>
                                                </base-input>
                                            </b-col>
                                            <b-col cols="2">
                                                <base-input v-model="grn.allocate_qty" type="number" :label="language_terms['QTY']"></base-input>
                                            </b-col>
                                            <b-col cols="2">
                                                <base-input v-model="grn.lot_reference" type="text" :label="language_terms['LOT_NUMBER']" :disabled="grn.has_lot == '0'"></base-input>
                                            </b-col>
                                            <b-col cols="2">
                                                <base-input :label="language_terms['EXPIRY_DATE']" v-if="grn.expiry_mths">
                                                    <flat-picker
                                                        slot-scope="{ focus, blur }"
                                                        @on-open="focus"
                                                        @on-close="blur"
                                                        style="background-color: white"
                                                        class="form-control datepicker"
                                                        v-model="grn.expiry_date">
                                                    </flat-picker>
                                                </base-input>     
                                                <base-input type="date" :label="language_terms['EXPIRY_DATE']"  v-model="grn.expiry_date" v-else disabled/>                               
                                            </b-col>
                                            <b-col lg="11" v-if="(grn.type == 'GRN' && grn.is_trade == '1')">
                                                <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                                <multiselect
                                                        v-model="grn.trade_item"
                                                        label="product_name"
                                                        track-by="product_name"
                                                        placeholder="Type to search"
                                                        open-direction="bottom"
                                                        :options="tradeitem_desp_list"
                                                        :multiple="false"
                                                        :searchable="true"
                                                        :clear-on-select="false"
                                                        :close-on-select="true"
                                                        :options-limit="300"
                                                        :limit="50"
                                                        :max-height="600"
                                                        :show-no-results="false"
                                                        :hide-selected="true"
                                                        @search-change="asyncFindTradeItemDesp($event)"
                                                        :internalSearch = "false"
                                                        :taggable="true"
                                                        @tag="addTag($event)"
                                                        @select="onSelectTradeItemDesp($event)"
                                                    >
                                                </multiselect>
                                            </b-col>
                                            <b-col cols="1" class="mt-4">
                                                <base-button icon type="success" @click="clickOnAdd" class="mt-1">
                                                    {{language_terms['ADD']}}
                                                </base-button>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-4" v-if="grn.items.length > 0 && grn.type == 'GRN'">
                                            <b-col cols="12">
                                                <b-table-simple hover responsive>
                                                    <b-thead head-variant="light">
                                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                        <b-th>{{language_terms['QTY']}}</b-th>
                                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                                        <b-th>{{language_terms['REMARKS']}}</b-th>
                                                        <b-th></b-th>
                                                    </b-thead>
                                                    <b-tbody v-for="(item, index) in grn.items" :key="index">
                                                        <tr>
                                                            <td>{{item.product_code}}</td>
                                                            <td>{{item.product_name}}</td>
                                                            <td>{{item.allocate_qty}}</td>
                                                            <td>{{item.lot_reference ? item.lot_reference : '-'}}</td>
                                                            <td>{{item.expiry_date ? item.expiry_date : '-'}}</td>
                                                            <td>{{item.location_name}}</td>
                                                            <td>{{item.remarks}}</td>
                                                            <td>
                                                                <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                                                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" v-if="item.lots.length"><i class="fa fa-angle-down"></i></base-button>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.is_collapsed">
                                                            <td colspan="7">
                                                                <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                                    <b-table-simple responsive>
                                                                    <b-thead head-variant="light">
                                                                            <b-th>{{language_terms['LOCATION']}}</b-th>
                                                                            <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                                            <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                                            <b-th>{{language_terms['LOT_QTY']}}</b-th>
                                                                            <b-th>{{language_terms['ALLOCATE_QTY']}}</b-th>
                                                                    </b-thead>
                                                                    <b-tbody v-for="(lot, j) in item.lots" :key="j">
                                                                        <td>{{lot.location_name}}</td>
                                                                        <td>{{lot.lot_reference}}</td>
                                                                        <td>{{lot.expiry_date}}</td>
                                                                        <td>{{lot.qty}}</td>
                                                                        <td>
                                                                            <input v-model="lot.allocate_qty" type="number" class="form-control"/>                                                                   
                                                                        </td>
                                                                    </b-tbody>
                                                                    </b-table-simple>
                                                                </b-collapse>
                                                            </td>
                                                        </tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-4" v-if="grn.items.length > 0 && grn.type == 'GRN_PO'">
                                            <b-col cols="12">
                                                <b-table-simple hover responsive>
                                                    <b-thead head-variant="light">
                                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                        <b-th>{{language_terms['PO_QTY']}}</b-th>
                                                        <b-th>{{language_terms['BALANCE']}}</b-th>
                                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                                        <b-th>{{language_terms['QTY']}}</b-th>
                                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                        <b-th></b-th>
                                                    </b-thead>
                                                    <b-tbody v-for="(item, index) in grn.items" :key="index">
                                                        <tr>
                                                            <td>{{item.product_code}}</td>
                                                            <td>{{item.product_name}}</td>
                                                            <td>{{item.qty}}</td>
                                                            <td>{{item.balance_qty}}</td>
                                                            <td>
                                                                <el-select v-model="item.location" filterable :placeholder="language_terms['LOCATIONS']"  
                                                                    value-key="id" @change="onSelectLocationForItem(index, item)">
                                                                    <el-option
                                                                        v-for="option in item.locations"
                                                                        :key="option.id"
                                                                        :label="option.name"
                                                                        :value ="option">
                                                                    </el-option>
                                                                </el-select>
                                                            </td>
                                                            <td><input v-model="item.allocate_qty" type="number" class="form-control"/></td>
                                                            <td><input v-model="item.lot_reference" type="number" class="form-control" :disabled="item.is_disabled == '1'"/></td>
                                                            <td>
                                                            <input v-model="item.expiry_date" type="date" class="form-control" :disabled="item.is_disabled == '1'"/>
                                                            </td>
                                                            <td>
                                                                <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                                                            </td>
                                                        </tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-col>
                                        </b-row>
                                    </tab-content>
                                </form-wizard>
                            </b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col cols="6">
                                <base-input :label="language_terms['VENDOR']" :placeholder="language_terms['VENDOR']" v-model="grn.contact_name" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['DATE']" :placeholder="language_terms['DATE']" v-model="grn.movement_date" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['WAREHOUSE']" :placeholder="language_terms['WAREHOUSE']" v-model="grn.location_name" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['REFERENCE']" :placeholder="language_terms['REFERENCE']" v-model="grn.reference_code" disabled></base-input>
                            </b-col>
                            <b-col cols="12">
                                <base-input :label="language_terms['REMARKS']" >
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="grn.remarks" disabled></textarea>
                                </base-input>
                            </b-col>
                            <b-col cols="12">
                                <h3>{{language_terms['GRN_ITEMS']}}</h3>
                                <b-table-simple hover responsive class="mt-3">
                                    <b-thead head-variant="light">
                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                        <b-th>{{language_terms['QTY']}}</b-th>
                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                    </b-thead>
                                    <b-tbody>
                                        <tr v-for="(item, index) in grn.items" :key="index">
                                            <td>{{item.product_code}}</td>
                                            <td>{{item.product_name}}</td>
                                            <td>{{item.qty}}</td>
                                            <td>{{item.lot_reference}}</td>
                                            <td>{{item.expiry_date}}</td>
                                            <td>{{item.location_name}}</td>
                                        </tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="1">
                                <base-button icon type="primary" @click.native ="goBack" v-if="$route.params.id != '_new'">
                                    {{language_terms['BACK']}}
                                </base-button>
                            </b-col>
                            <b-col cols="2">
                                <printDocument :data="grn" v-if="($route.params.id != '_new')"></printDocument> 
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from "vuex";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Select, Option } from "element-ui";

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import productLookup from "@/components/Autocomplete.vue";
import moment from "moment";

import printDocument from "./printGRN.vue"

export default {
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
        grn_data:(state) => state.grns.data,
        warehouses:(state)=>state.locations.warehouses,
        is_stockcard_created:(state) => state.stockcards.is_stockcard_created,
        po_list:(state) => state.purchase.po_list,
        po_items:(state) => state.purchase.po_items
      }),
    },
    components:{
        FormWizard,
        TabContent,
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        printDocument
    },
    data(){
        return{
            pos:[],
            tradeitem_desp_list:[],
            desp_tags:[],
            loading: false,
            vendors:[],
            locations:[],
            is_confirmed:0,
            grn:{
                reference_id:"",
                expiry_mths:null,
                location:{},
                location_id:"",
                location_code:"",
                location_name:null,
                available_qty:null,
                has_lot:"0",
                expiry_mths:null,
                is_trade:0,
                allocate_qty:null,
                type:"GRN",
                contact_id:'',
                contact_code:"",
                contact_name:'',
                movement_date:null,
                warehouse_id:null,
                product_name:"",
                product_id:"",
                product_code:"",
                items:[],
                remarks:"",
                trade_item:{},
                vendor:{
                    id:"",
                    code:"",
                    name:""
                }
            },
            types:[
                {
                    code:"GRN_PO",
                    name:"GRN_FROM_PO"
                },
                {
                    code:"GRN",
                    name:"GOOD_RECEIVE_NOTE"
                }
            ],
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"]
        }
    },
    methods:
    {
        isFoundInList(name)
        {
            let is_found = 0
            for(let i = 0; i < this.desp_tags.length; i++)
            {
                if(this.desp_tags[i].product_name == name)
                {
                    is_found = 1
                }
            }
            return is_found;
        },
        onSelectTradeItemDesp(selectedOption)
        {
            if(selectedOption)
            {
                this.grn.product_name = selectedOption.product_name
            }
        },
        addTag(newTag)
        {
            if(newTag)
            {
                let obj = {product_name: newTag, contact_id:this.grn.contact_id, date:this.grn.movement_date}
                if(this.isFoundInList(newTag) == 0)
                {
                    this.desp_tags.push(obj)
                    Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
                    this.grn.trade_item = obj
                    this.grn.product_name = newTag
                }

            }
        },
        async asyncFindTradeItemDesp (query) 
        {
            let product_id = this.grn.product_id
            let pv = { value: query, contact_id:this.grn.contact_id, date:this.grn.movement_date, product_id: product_id};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
                Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
        },
        onSelectLocationForItem(index, item)
        {
            let selectedOption = item.location
            if(selectedOption)
            {
                item.location_id = selectedOption.id
                item.location_code = selectedOption.code
                item.location_name = selectedOption.name
                this.$set(this.grn.items, index , item) 
            }
        },
        deleteItem(index)
        {
            this.grn.items.splice(index, 1);
        },
        handleCollaspe(index, row)
        {
            if(row.is_collapsed)
            {
                row.is_collapsed = false
            }
            else
            {
                row.is_collapsed = true
            }

            this.$set(this.grn_items, index , row) 
        },
        clickOnAdd()
        {
            if(this.grn.allocate_qty == '' || this.grn.allocate_qty == null || this.grn.allocate_qty ==  0 || this.grn.location_id == '')
            {
                alert("Location / Qty Required")
            }
            else
            {   
                if(this.grn.product_name == '' )
                {
                    alert("Product Name Required!")
                }
                else
                {
                    if(this.grn.type == 'GRN')
                    {
                        this.addToList()
                    }
                }
            }
        },
        addToList()
        {
            this.grn.items.push(
            {
                is_collapsed:false,
                lots:[],
                warehouse_id:this.grn.warehouse_id,
                product_id:this.grn.product_id,
                product_code:this.grn.product_code,
                product_name:this.grn.product_name,
                location_id:this.grn.location_id,
                location_code:this.grn.location_code,
                location_name:this.grn.location_name,
                allocate_qty:this.grn.allocate_qty,
                lot_reference:this.grn.lot_reference,
                expiry_date:this.grn.expiry_date,
                remarks:this.grn.item_remarks
            })

            this.grn.location = {}
            this.grn.location_id = '';
            this.grn.location_code = '';
            this.grn.location_name= '';

            this.grn.product_code = '';
            this.grn.product_id = '';
            this.grn.product_name = "",
            this.grn.has_lot = 0;
            this.grn.expiry_date = null,
            this.grn.allocate_qty = '',
            this.grn.expiry_mths = ""
            this.grn.trade_item = {}
        },
        onSelectLocation(selectedOption)
        {
            if(selectedOption)
            {
                this.grn.location_id = selectedOption.id
                this.grn.location_code = selectedOption.code
                this.grn.location_name = selectedOption.name
                this.grn.available_qty = selectedOption.available_qty
            }
        },
        async onSelectVendor(selectedOption)
        {
            if(selectedOption)
            {
                if(selectedOption.id)
                {

                    if(this.grn.contact_id != selectedOption.id)
                    {
                        this.grn.items = []
                    }
                  
                    this.grn.contact_id = selectedOption.id;

                    if(this.grn.type == 'GRN_PO')
                    {
                        await this.$store.dispatch("purchase/fetchPosForGRN" , {contact_id:selectedOption.id})
                        console.log(this.po_list)

                        if(this.po_list)
                        {
                            this.pos = this.po_list
                        }
                    }
                }
            }
        },
        async asyncFindVendor(query)
        {
            let pv = { value: query };
            await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        this.vendors = response.data.data;
                    } else {
                        this.vendors = [];
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.msg)
                    } else {
                        console.log("Problem submitting New Post", error);
                    }
            });
        },
        async selectProduct(obj)
        {
            if(obj)
            {
                this.grn.expiry_date = null
                this.grn.product_id = obj.id
                this.grn.product_code = obj.code
                this.grn.product_name = obj.name
                this.grn.has_lot = obj.has_lot
                this.grn.expiry_mths = obj.expiry_mths
                this.grn.is_trade = obj.is_trade


                if(this.grn.is_trade == '1')
                {
                    this.grn.product_name = ''
                }

                if(this.grn.date && this.grn.expiry_mths)
                {
                    this.grn.expiry_date = moment(this.grn.date).add(this.grn.expiry_mths, "months").format("YYYY-MM-DD");
                }

                await this.asyncFindLocation()
            }
        },
        async asyncFindLocation()
        {
            let pv = {warehouse_id: this.grn.warehouse_id, product_id:this.grn.product_id, direction:'IN', date:this.grn.date};
            await axios.post(apiRoutes['LOOKUP_LOCATIONS_BY_WH'], pv, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.locations = response.data.data;
                } 
                else 
                {
                    this.locations = [];
                }
                this.isLoading = false;
            }).catch((error) => {
                
            if (error.response) {
                alert(error.response.data.msg)
            } else {
                console.log("Problem submitting New Post", error);
            }
            });
        },
        goBack(){
            this.$router.push("/inventory/grns")
        },
        onComplete()
        {
            this.createStockCard()
        },
        async beforeStepChangeFirstTab()
        {
            let isValid = false
            if(this.grn.contact_id && this.grn.date && this.grn.type == 'GRN')
            {
                isValid = true
            }
            else if(this.grn.type == 'GRN_PO')
            {
                if(this.grn.reference_id != '' && this.grn.reference_id != null)
                {
                    await this.$store.dispatch("purchase/fetchPoItems", {document_id:this.grn.reference_id, warehouse_id:this.grn.warehouse_id, movement_date:this.grn.date })
                    this.grn.items = this.po_items
                    isValid = true
                }
                else
                {
                    alert("Please select a purchase order!")
                }
            }

            return isValid
        },
        async createStockCard()
        {
            if(this.is_confirmed == 0)
            {
                let payload = {
                                warehouse_id:this.grn.warehouse_id, 
                                reference_id:this.grn.reference_id,
                                remarks:this.grn.remarks,
                                movement_date:this.grn.date, 
                                items:this.grn.items, 
                                direction:'IN',
                                type:this.grn.type,
                                contact_id:this.grn.contact_id,
                                is_confirmed:0
                           }
                await this.$store.dispatch("stockcards/create", payload)

                if(this.is_confirmation_required == 1)
                {
                    let messages = this.confirmation_messages
                    let msg = '';
                    if (Array.isArray(messages)) {
                        msg = messages.join("\n")
                    }
                    let response = await this.$confirm(msg, this.language_terms['CONFIRMATION'], {
                        confirmButtonText: this.language_terms['CONFIRM'],
                        cancelButtonText: this.language_terms['CANCEL'],
                        type: 'warning'
                        }).catch(() => 
                        {
                            this.$message.info(this.language_terms['ACTION_CANCEL'])
                        })
                        if (response === 'confirm') 
                        {
                            this.loading = true
                            await this.confirmCreateStockCard()
                            this.loading = false
                        }
                }
            }
            else
            {
                await this.confirmCreateStockCard()
            }

            if(this.is_stockcard_created == 1)
            {
                this.$router.push("/inventory/grns")
            }
        },
        async confirmCreateStockCard()
        {
            let payload = {
                        warehouse_id:this.grn.warehouse_id, 
                        reference_id:this.grn.reference_id,
                        remarks:this.grn.remarks,
                        movement_date:this.grn.date, 
                        items:this.grn.items, 
                        direction:'IN',
                        type:this.grn.type,
                        contact_id:this.grn.contact_id,
                        is_confirmed:1
            }
            await this.$store.dispatch("stockcards/create", payload)
        },
    },
    async mounted()
    {
        this.loading = true
        let document_code = this.$route.params.id
        
        if(document_code == '_new')
        {
            if(!this.grn.date)
            {
                this.grn.date = moment().format("YYYY-MM-DD");
            }
        }
        else
        {
            await this.$store.dispatch("grns/fetch", {code:this.$route.params.id});
            this.grn = this.grn_data
        }
        await this.$store.dispatch("locations/fetchWarehouses", {});

        if(this.warehouses.length > 0)
        {
            if(!this.grn.warehouse_id)
            {
                this.grn.warehouse_id = this.warehouses[0].id
            }
        }

        this.loading = false
    }
}
</script>
